import { configureStore } from "@reduxjs/toolkit";

import remoteElaborations from "../feature/object/remote-elaborations-slice";
import navigationsSlice from "../feature/general/navigation-slice";
import sessionSettings from "../feature/general/session-settings-slice";
import configurations from "../feature/settings/configurations-slice";
import externalConfigs from "../feature/settings/external-configs-slice";
import panelMessage from "../feature/panelMessage/panelMessage-slice";

import downloadDocumentCopy from "../feature/document/download-document-slice";

export const store = configureStore({
  reducer: {
    // settings: settingsReducer,
    configurationState: configurations,
    externalConfigurations: externalConfigs,
    sessionSettings: sessionSettings,
    // user: userReducer,
    remoteElaborations: remoteElaborations,
    navigation: navigationsSlice,
    // officeDocument: officeDocumentSlice,

    panelMessage: panelMessage,

    downloadDocumentCopy,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
